import axios from '@plugins/axios'
import config from '@src/app.config'
const env = config.env
const { server_url: serverUrl } = config[env]

export const state = {
  runSession: {},
}

export const getters = {
  assessmentRunSession: (state) => state.runSession,
}

export const mutations = {
  CACHE_RUN_SESSION(state, data) {
    state.runSession = data
  },
}

export const actions = {
         // getRunSession({ commit }, params) {
         //   commit('CACHE_RUN_SESSION', {})
         //   return axios.get(`${serverUrl}/assessment/assessment_run_sessions/`, {
         //     params,
         //   }).then(({ data }) => {
         //     if (data.results.length > 0) {
         //       commit('CACHE_RUN_SESSION', data.results[0])
         //       return data.results[0]
         //     }
         //   })
         // },

         // createUpdateRunSession({ commit }, { action, payload }) {
         //   let method = 'post'
         //   let url = `${serverUrl}/assessment/assessment_run_sessions/`
         //   if (action === 'update') {
         //     method = 'put'
         //     url = payload.url
         //   }
         //   return axios[method](url, payload).then(({ data }) => {
         //     commit('CACHE_RUN_SESSION', data)
         //     return data
         //   })
         // },
         cleanRunSession({ commit }) {
           commit('CACHE_RUN_SESSION', {})
         },

         findCurrentRunSession({ commit }, params) {
           commit('CACHE_RUN_SESSION', {})
           return axios
             .get(
               `${serverUrl}/assessment/assessment_run_sessions/current_session/`,
               {
                 params,
               }
             )
             .then(({ data }) => {
               commit('CACHE_RUN_SESSION', data)
               return data
             })
         },

         fetchAssessmentRunSessionIndividualReport(_, assessmentRunSessionUrl) {
           return axios.get(`${assessmentRunSessionUrl}individual_report/`)
         },

         fetchAssessmentRunSessionReports(_, query = '') {
           return axios.get(
             `${serverUrl}/assessment/assessment_run_sessions/get_reports/${query}`
           )
         },

         fetchAssessmentRunSessionDemographic(_, query = '') {
           return axios.get(
             `${serverUrl}/assessment/assessment_run_sessions/get_reports_demographics/${query}`
           )
         },
         fetchAssessmentRunSessionDemographicGeneral(_, query = '') {
           return axios.get(
             `${serverUrl}/assessment/assessment_run_sessions/get_general_demographic/${query}`
           )
         },
         fetchAssessmentRunSessionReportsGeneral(_, query = '') {
           return axios.get(
             `${serverUrl}/assessment/assessment_run_sessions/get_stress_reports/${query}`
           )
         },

         generateReports(_, assessmentRunSessionUrl) {
           return axios.post(`${assessmentRunSessionUrl}generate_reports/`)
         },
       }
